import { useNavigate } from "react-router-dom";
import { CompanyDetails } from "../../services/types";

interface AddInteractionButtonProps {
    id?: string;
    company?: CompanyDetails | null;
}

function AddInteractionButton({ id, company }: AddInteractionButtonProps) {
    const navigate = useNavigate();
    
    const handleClick = () => {
        const state: any = {};

        if (id) {
            state.id = id;
        }

        if (company) {
            state.company = company;
        }

        navigate('/commerce-interactions/addinteraction', { state });
    };

    return ( 
        <span className="flex items-center mt-2 sm:mt-0">
        <button
            id="add-interaction"
            onClick={handleClick}
            className="w-40 px-3 mr-4 text-white font-bold text-sm bg-button-blue border border-solid border-button-blue rounded-md focus:outline-none focus:border-blue-500 hover:border-color-cai-blue hover:bg-color-cai-blue h-[36px] appearance-none text-center"
        > + Add Interaction
        </button>
        </span>
    );
}

export default AddInteractionButton;